export const GUARDIAN_SEARCH_DEFAULT_PAGE_SIZE = 30;
export const GUARDIAN_SEARCH_MAX_PAGE_SIZE = 100;
export const AUDIT_SEARCH_DEFAULT_PAGE_SIZE = 30;
export const AUDIT_MAX_PAGE_SIZE = 100;
export const COMMUNITY_TIMEOUT_MILLIS = 5000;

export const WEEKLY_CAMPAIGN_KEY = "qustodio_launch_campaign_recurrent_v2";
